<div class="d-flex flex-column flex-md-row align-items-md-center p-4 p-md-10">
  <img src="assets/images/clock.webp" alt="clock" width="280" height="280" class="mx-auto" />

  <div class="mt-6 mt-md-0 ml-md-10 w-400">
    @let autoQuote = autoQuote$ | async;
    @let agentDisplay = (autoQuote?.salesAgent?.fullName ?? '').trim();

    <h1 class="semi-bold" data-id="title">These options are no longer available</h1>

    <p class="mt-2">The pricing you viewed is no longer current.</p>

    <p class="mt-2">
      @if (agentDisplay) {
        <strong>{{ agentDisplay }}</strong> (your travel expert)
      } @else {
        Your travel expert
      }
      can quickly provide updated options — just reply to your email or reach out directly.
    </p>

    @let commonData = commonDataService.getData() | async;
    @let phone =
      (autoQuote?.salesAgent?.phone ?? '') ||
      (commonData?.phone ?? commonData?.helpCenterPhone ?? '');

    @if (phone) {
      <div class="mt-6">
        <ds-button
          [href]="'tel:' + phone"
          (click)="callExpertPressed()"
          leadingIcon="phone"
          [fullWidth]="true"
          data-id="call-expert"
          label="Call your expert"
        />
      </div>
    }
  </div>
</div>
